document.addEventListener('DOMContentLoaded', () => {
  // Mobile Navigation Toggle - Progressive enhancement for checkbox-based navigation
  const navToggleCheckbox = document.querySelector(
    '.nav-toggle__checkbox'
  ) as HTMLInputElement;
  const navToggle = document.querySelector('.nav-toggle');
  const navOverlay = document.querySelector('.nav-overlay');

  // The menu works without JavaScript using checkbox :checked state
  // JavaScript provides enhanced experience: better animations, keyboard support, focus management

  if (navToggleCheckbox && navToggle && navOverlay) {
    // Close menu when overlay is clicked (uncheck the checkbox)
    navOverlay.addEventListener('click', () => {
      navToggleCheckbox.checked = false;
    });

    // Close menu on Escape key
    document.addEventListener('keydown', e => {
      if (e.key === 'Escape' && navToggleCheckbox.checked) {
        navToggleCheckbox.checked = false;
        (navToggle as HTMLElement).focus(); // Return focus to toggle button
      }
    });
  }

  // Handle window resize - close mobile menu if resizing to desktop
  let resizeTimer: number;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = window.setTimeout(() => {
      if (window.innerWidth > 1300 && navToggleCheckbox?.checked) {
        navToggleCheckbox.checked = false;

        // Uncheck all submenu checkboxes
        document.querySelectorAll('.nav-menu__checkbox').forEach(checkbox => {
          (checkbox as HTMLInputElement).checked = false;
        });
      }
    }, 250);
  });
});
